import { ContentChild, Directive, inject, Type } from '@angular/core';

import { TemplateResolver } from '../../template-resolver';
import { DEFAULT_SELECTED_ITEM_COMPONENT, Select2ItemComponent } from './selected-item.component';
import { Select2SelectedItemDirective } from './selected-item.directive';

@Directive({
  standalone: true,
  selector: 'rt-select2-list-item-resolver',
})
export class SelectedItemResolverDirective extends TemplateResolver<
  Select2SelectedItemDirective<any>,
  { optional: false }
> {
  @ContentChild(Select2SelectedItemDirective)
  public override contentDirective?: Select2SelectedItemDirective<any>;
  public override injectedComponent = <Type<Select2ItemComponent>>(
    (<unknown>inject(Select2ItemComponent, { optional: true }))
  );
  public override defaultComponent =
    inject(DEFAULT_SELECTED_ITEM_COMPONENT, { optional: true }) ?? Select2ItemComponent;
}
